import { Theme } from '@mui/material';

export const RECORDS_LIST_BULK_BAR_CLEARANCE = '13rem';

export const getRecordRowBackgroundColor = (theme: Theme, isActive: boolean) =>
  isActive
    ? theme.palette.custom.OV.sys.surfaceContainerHigh
    : theme.palette.custom.OV.sys.surfaceContainerLowest;
